export const AuthenticationContants = {
  keyTokenLocalStorage: "token_user",
  keyMenuUserLocalStorage: "menu_user",
  keyWindowsOpenedLocalStorage: "windows_opened",
  keyNitCLient: "nit_client"
}